export enum AccountingEqualityOperators {
Equals,
NotEquals,
HasValue,
}
